import { RootState } from '../../../redux/store.model';

export const getDeviceManagerModalStateSelector = (state: RootState) =>
  state.deviceManagerPage.modal;
